import { Grid, Menu, MenuItem, Modal } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import { OrangeButton, PrimaryButton } from 'components/Button';
import { ShortBody, SmallSectionHeader } from 'components/Typography';
import React from 'react';
import styled from 'styled-components';

export const Container = styled(Grid)`
  background: linear-gradient(0deg, rgba(0, 0, 0, 0) 15%, #000000 116%);
  height: 78px !important;
  margin-top: 0px !important;
  padding: 0px !important;
  position: absolute !important;
`;
export const IconContainer = styled(Grid)`
  align-self: flex-start;
  }
`;

export const StyledCloseIcon = styled(CloseIcon)`
  && {
    color: #ffffff;
    height: 31px;
    width: 28px;
  }
`;
export const NavWrapper = styled.div`
  margin-left: 0;
  padding: 20px 0;
  margin-top: 0px;
  font-size: 1.3em;
`;

export const IconBlock = styled('img')<{ isClickable: boolean }>`
  margin-top: -8px !important;
  margin-left: 80px !important;
  margin-right: 80px !important;
  cursor: ${({ isClickable }) => (isClickable ? 'pointer' : null)};

  @media (max-width: 600px) {
    margin: 0px !important;
    height: 55px;
    width: 137px;
  }
`;
export const StyledGridNav = styled(Grid)`
  margin-left: 40px !important;
  margin-right: 15px !important;
`;

export const StyledPrimaryButton = styled(PrimaryButton)`
  &&& {
    padding: 0;
    height: 32px;
    width: 32px;
    min-width: 32px;
    margin: 8px;
  }
`;

export const StyledLanguageButton = styled(PrimaryButton)`
  &&& {
    padding: 0 8px;
    height: 32px;
    width: 59px;
    margin: 8px;
    h6 {
      color: #ffffff;
      margin: 0 2px;
      font-size: 9px !important;
      font-weight: 500;
    }
  }
`;

export const StyledProfileSettings = styled(PrimaryButton)`
  && {
    padding: 0 8px;
    height: 32px;
    width: 35px;
    margin: 8px;
    font-size: 10px !important;
    img {
      margin: 0 3px;
    }
  }
`;

export const StyledMenuSettings = styled(PrimaryButton)`
  && {
    padding: 0 4px;
    height: 32px;
    width: 32px;
    min-width: 32px;
    margin: 8px;
  }
`;

export const StyledLogoutButton = styled(StyledProfileSettings)`
  && {
    width: 80px;
  }
`;

export const StyledOrangeButton = styled(({ reverse, ...otherProps }) => (
  <OrangeButton {...otherProps} />
))`
  && {
    width: 200px;
    padding: 8px 16px;
    font-size: 13px !important;
    height: 32px;
    margin: 8px;
    img {
      width: 16px;
      height: 16px;
      margin-right: ${(props) => (props.reverse ? '0px' : '8px')};
      margin-left: ${(props) => (props.reverse ? '8px' : '0px')};
    }
  }
`;

export const ActionButtonsGrid = styled(Grid)`
  && {
    text-align: end;
  }
`;
export const StyledShortBody = styled(ShortBody)`
  &&& {
    size: 16px !important;
    line-height: 28px !important;
    padding-right: 20px !important;
    font-weight: 400 !important;
  }
`;
/* istanbul ignore next */
export const StyledShortText = styled(({ reverse, ...otherProps }) => (
  <ShortBody {...otherProps} />
))`
  &&& {
    font-size: 10px !important;
    margin-top: 10px !important;
    padding-right: ${(props) => (props.reverse ? '20px' : '0px')};
  }
`;
export const StyledImg = styled.img`
  margin-top: 5px;
  height: 24px;
  width: 24px;
`;
export const StyledImgIcon = styled.img`
  margin-top: 15px;
  height: 24px;
  width: 24px;
`;

export const StyledMenu = styled(Menu)`
  &&& {
    ul {
      padding: 0px;
    }
    li {
      padding: 0 10px;
    }
    .MuiRadio-colorSecondary.Mui-checked {
      color: #32c284;
    }
    .MuiPopover-paper {
      margin-top: 5px;
      border-radius: 8px;
    }
  }
`;
export const StyledMenuItem = styled(MenuItem)`
  && {
    .MuiPopover-paper {
      margin-top: 14px;
    }
  }
`;
export const StyledGrid = styled(Grid)`
  margin-top: -20px !important;
`;
export const StyledSmallSectionHeader = styled(SmallSectionHeader)`
  margin-bottom: 0 !important;
  color: white !important;
`;
export const StyledModal = styled(Modal)`
  opacity: 0.98;
  background: linear-gradient(211.13deg, #489edc 0%, #07416a 100%);
  height: 742px;
  min-width: 375px;

  .MuiIconButton-label,
  .MuiFormControlLabel-label {
    color: white;
  }
`;
